import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import { vehicleColumns } from './RecordCells';
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
class MotosTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true,
            loading:false,
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleVehicleDetail = (vehicleId) => {
        this.props.history.push(`/moto-detail/${vehicleId}`);
    }
    handleDelete = async (vehicleId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/vehicle/delete/'+vehicleId,'delete');
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Kullanıcı başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const { pending } = this.state;
        const {userPermissions} = this.props;
        const userHasViewVehiclePermission = userPermissions.includes('view vehicle');
        const userHasDeleteVehiclePermission = userPermissions.includes('delete vehicle');
        const columns = vehicleColumns({ motor: true, canView: userHasViewVehiclePermission, canDelete: userHasDeleteVehiclePermission, onView: row => this.handleVehicleDetail(row.id), onDelete: row => this.handleDelete(row.id) });

        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/vehicle/moto/all"}
                columns={columns}
                onRowClicked={userHasViewVehiclePermission ? row => this.handleVehicleDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(MotosTable));
